"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Grid from "@mui/material/Grid" // Grid version 2
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import {
  PRIMARY_BLACK_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../shared/constants"
import { ICON_AND_REASONS } from "./shared/constants"
import IconAndReason from "./shared/IconAndReason"
import Header from "../shared/Header"
import map from "lodash/map"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"
import SectionContainer from "../shared/SectionContainer"

function WhyPostHere() {
  const [{ isLoggedIn }, { getRouteForLeaderOnboarding }] =
    useRedirectToLeaderOnboarding()

  const renderHeader = () => {
    return <Header text="Why mental health group leaders are posting here" />
  }

  const renderButtons = () => {
    return (
      <PrimaryAndSecondaryButtonsContainer
        button1={{
          type: PRIMARY_BLACK_BUTTON_TYPE,
          text: "Post your group",
          href: getRouteForLeaderOnboarding(),
        }}
        button2={{
          type: SECONDARY_BUTTON_TYPE,
          text: "Join community",
          href: "/signup",
        }}
      />
    )
  }

  const renderIconAndReason = ({ iconType, title, description, index }) => {
    return (
      <IconAndReason
        iconType={iconType}
        title={title}
        description={description}
        key={`why-reason-${index}`}
      />
    )
  }
  const renderIconsAndReasons = () => {
    return (
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        sx={{
          margin: 0,
          justifyContent: "space-around",
        }}
      >
        {map(ICON_AND_REASONS, ({ iconType, title, description }, index) => {
          return renderIconAndReason({ iconType, title, description, index })
        })}
      </Grid>
    )
  }

  return (
    <SectionContainer>
      {renderHeader()}
      {renderIconsAndReasons()}
      {renderButtons()}
    </SectionContainer>
  )
}
export default WhyPostHere
